import React, { FC, useEffect, useState } from 'react';
import { Box, Button, Flex, Switch } from '@chakra-ui/react';

import { Dialog } from '@app/components/common/modals';
import { AutocompleteField, SwitchField, TextField } from '@app/components/common';
import { useQueryTable } from '@app/components/common/table/query-table';
import { useApi } from '@app/hooks';
import { SubChannel } from '@app/api';

interface SubChannelFormProps {
  open: boolean;
  channels: EntityBase[];
  setOpen(value: boolean): void;
  subChannel?: SubChannel;
}

const SubChannelForm: FC<SubChannelFormProps> = ({ open, channels, setOpen, subChannel }) => {
  const [channelName, setChannelName] = useState<string>(subChannel?.channel || '');
  const [subChannelName, setSubChannelName] = useState<string>(subChannel?.sub_channel || '');
  const [is_active, setIsActive] = useState<boolean>(subChannel?.is_active || false);
  const [loading, setLoading] = useState(false);
  const { refetch } = useQueryTable();
  const api = useApi();

  const onSubmit = async () => {
    setLoading(true);
    try {
      if (subChannel) {
        await api.acb.updateChannel({ 
          id: subChannel.id, 
          channel: channelName, 
          sub_channel: subChannelName, 
          is_active 
        });
      } else {
        await api.acb.createChannel({
          channel: channelName,
          sub_channel: subChannelName,
        });
      }
      setLoading(false);
      setOpen(false);
      refetch();
    } catch (e) {
      console.log(e);
      setLoading(false);
      return;
    }
  };

  useEffect(() => {
    setChannelName(subChannel?.channel || '');
    setSubChannelName(subChannel?.sub_channel || '');
    setIsActive(subChannel?.is_active);
  }, [subChannel]);

  return (
    <Dialog
      title="Канал/Подканал"
      open={open}
      onClose={() => setOpen(false)}
      loading={loading}
      actions={
        <>
          <Button onClick={onSubmit}>
            {!subChannel ? 'Добавить' : 'Изменить'}
          </Button>
        </>
      }
    >
      <Flex mb={1} flexDirection='column' gap={4}>
        <AutocompleteField
          id=""
          label="Канал"
          value={channelName}
          name='channel'
          valueProperty='name'
          onChangeText={setChannelName}
          options={channels}
        />
        <TextField
          id=""
          label="Подканал"
          value={subChannelName}
          onChange={setSubChannelName}
        />
        {subChannel && <SwitchField 
          label='Активен'
          value={is_active}
          onChange={setIsActive}
          id='is_active'
        />}
      </Flex>
    </Dialog>
  );
};

export default SubChannelForm;
